import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import 'owl.carousel/dist/assets/owl.carousel.css';
import * as Sentry from "@sentry/react";
import './normalize.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './config/i18n';
import { singBrowser } from './Utils/helpers';

Sentry.init({
  dsn: "https://1e77fe045926c410599fa6347b94c094@o4509412840112128.ingest.us.sentry.io/4509412846206976",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()]
});

Sentry.addEventProcessor((event, hint) => {
  const originalError = hint.originalException;

  if (
    originalError instanceof Error &&
    (
      originalError.message.includes("removeChild") ||
      originalError.message.includes("insertBefore")
    )
  ) {
    event.extra = {
      ...event.extra,
      url: window.location.href,
      userAgent: navigator.userAgent,
      domSnapshot: document.body ? document.body.innerHTML.slice(0, 5000) : null,
      activeElement: document.activeElement?.outerHTML || null,
      reactVersion: React?.version || null,
      timestamp: new Date().toISOString()
    };
  }
  return event;
});

window.addEventListener('error', function (event) {
  Sentry.captureException(event.error || new Error(event.message));
});

window.addEventListener('unhandledrejection', function (event) {
  Sentry.captureException(event.reason || new Error("Unhandled promise rejection"));
});

singBrowser();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>

      <App />

    </BrowserRouter>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
